import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';

import Config from '../../../helpers/Config';
import rootAction from '../../../stateManagment/actions/rootAction';
import { LOADER_DURATION } from '../../../helpers/Constants';
import { MakeApiCallAsync } from '../../../helpers/ApiHelpers';
import {
    checkIfStringIsEmtpy,
    showInfoMsg
} from '../../../helpers/ValidationHelper';

import {
    getLanguageCodeFromSession,
    GetLocalizationControlsJsonDataForScreen,
    replaceLoclizationLabel
} from '../../../helpers/CommonHelper';

import GlobalEnums from '../../../helpers/GlobalEnums';
import Wishlist from '../modal/Wishlist';

/* =========================================================
   AMAZON-STYLE COLOR PALETTE
========================================================= */

const COLORS = {
    darkest: '#0f1111',   // deepest footer band (copyright / back-to-top)
    dark: '#131921',      // main footer background (Amazon navy)
    darkAccent: '#232f3e', // section band background
    orange: '#ff9900',
    orangeHover: '#ffac33',
    textLight: '#ffffff',
    textMuted: '#cccccc',
    border: 'rgba(255,255,255,0.15)'
};

const Footer = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [displayLoginUserModal, setDisplayLoginUserModal] = useState(false);
    const [display, setDisplay] = useState(false);
    const [paymentMethods, setPaymentMethods] = useState([]);
    const [adminPanelBaseURL] = useState(Config['ADMIN_BASE_URL']);
    const [LocalizationLabelsArray, setLocalizationLabelsArray] = useState([]);

    const [LogoImageFromStorage, setLogoImageFromStorage] = useState(
        useSelector(
            state => state.commonReducer.websiteLogoInLocalStorage
        )
    );

    const [isMobile, setIsMobile] = useState(
        typeof window !== 'undefined'
            ? window.innerWidth <= 767
            : false
    );

    const totalCartItems = useSelector(
        state => state.cartReducer.totalCartItems
    );

    const loginUserDataJson = useSelector(
        state => state.userReducer.user
    );

    let loginUser = {};

    try {
        loginUser = JSON.parse(loginUserDataJson ?? "{}");
    } catch (error) {
        loginUser = {};
    }


    /* =========================================================
       MOBILE SCREEN DETECTION
    ========================================================= */

    useEffect(() => {

        const handleResize = () => {
            setIsMobile(window.innerWidth <= 767);
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };

    }, []);


    /* =========================================================
       BACK TO TOP
    ========================================================= */

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };


    /* =========================================================
       CART
    ========================================================= */

    const handleCart = (event) => {

        if (event) {
            event.preventDefault();
        }

        if (
            totalCartItems !== null &&
            totalCartItems !== undefined &&
            totalCartItems > 0
        ) {
            navigate(
                '/' +
                getLanguageCodeFromSession() +
                '/cart'
            );
        } else {
            showInfoMsg('No item exists in your cart');
        }
    };


    /* =========================================================
       LOGIN MODAL
    ========================================================= */

    const handleOpenCloseLoginUserModal = (event) => {

        if (event) {
            event.preventDefault();
        }

        setDisplayLoginUserModal(
            !displayLoginUserModal
        );
    };


    /* =========================================================
       WISHLIST
    ========================================================= */

    const handleWishlist = () => {
        setDisplay(!display);
    };


    /* =========================================================
       LOGOUT
    ========================================================= */

    const HandleLogout = (e) => {

        if (e) {
            e.preventDefault();
        }

        localStorage.setItem(
            "user",
            JSON.stringify({})
        );

        dispatch(
            rootAction.userAction.setUser('{}')
        );

        navigate('/', {
            replace: true
        });
    };


    /* =========================================================
       PAYMENT METHODS + WEBSITE LOGO
    ========================================================= */

    useEffect(() => {

        const DataOperationFunc = async () => {

            try {

                const headers = {
                    Accept: 'application/json',
                    'Content-Type': 'application/json'
                };

                const param = {
                    requestParameters: {
                        recordValueJson: "[]"
                    }
                };


                /* ---------------------------------------------
                   PAYMENT METHODS
                --------------------------------------------- */

                const responsePaymentMethods =
                    await MakeApiCallAsync(
                        Config.END_POINT_NAMES[
                            'GET_PAYMENT_METHODS'
                        ],
                        null,
                        param,
                        headers,
                        "POST",
                        true
                    );

                if (
                    responsePaymentMethods !== null &&
                    responsePaymentMethods.data !== null &&
                    responsePaymentMethods.data.data
                ) {

                    try {

                        const paymentData =
                            JSON.parse(
                                responsePaymentMethods.data.data
                            );

                        setPaymentMethods(
                            Array.isArray(paymentData)
                                ? paymentData
                                : []
                        );

                    } catch (error) {

                        console.error(
                            'Payment methods parse error:',
                            error
                        );

                    }
                }


                /* ---------------------------------------------
                   WEBSITE LOGO
                --------------------------------------------- */

                if (
                    !checkIfStringIsEmtpy(
                        LogoImageFromStorage
                    )
                ) {

                    const paramLogo = {
                        requestParameters: {
                            recordValueJson: "[]"
                        }
                    };

                    const logoResponse =
                        await MakeApiCallAsync(
                            Config.END_POINT_NAMES[
                                'GET_WEBSITE_LOGO'
                            ],
                            null,
                            paramLogo,
                            headers,
                            "POST",
                            true
                        );

                    if (
                        logoResponse !== null &&
                        logoResponse.data !== null &&
                        logoResponse.data.data !== ""
                    ) {

                        try {

                            const logoData =
                                JSON.parse(
                                    logoResponse.data.data
                                );

                            if (
                                logoData &&
                                logoData.length > 0
                            ) {

                                const WebsiteLogoInLocalStorage =
                                    logoData[0].AppConfigValue;

                                dispatch(
                                    rootAction.commonAction.setWebsiteLogo(
                                        WebsiteLogoInLocalStorage
                                    )
                                );

                                setLogoImageFromStorage(
                                    WebsiteLogoInLocalStorage
                                );
                            }

                        } catch (error) {

                            console.error(
                                'Logo parse error:',
                                error
                            );

                        }
                    }
                }

            } catch (error) {

                console.error(
                    'Footer data error:',
                    error
                );

            }
        };


        dispatch(
            rootAction.commonAction.setLoading(true)
        );

        DataOperationFunc().catch(console.error);


        const loaderTimer = setTimeout(() => {

            dispatch(
                rootAction.commonAction.setLoading(false)
            );

        }, LOADER_DURATION);


        return () => {
            clearTimeout(loaderTimer);
        };

    }, [dispatch, LogoImageFromStorage]);


    /* =========================================================
       LOCALIZATION
    ========================================================= */

    useEffect(() => {

        const dataOperationFunc = async () => {

            try {

                const arryRespLocalization =
                    await GetLocalizationControlsJsonDataForScreen(
                        GlobalEnums.Entities["Footer"],
                        null
                    );

                if (
                    arryRespLocalization &&
                    Array.isArray(arryRespLocalization) &&
                    arryRespLocalization.length > 0
                ) {

                    setLocalizationLabelsArray(
                        arryRespLocalization
                    );
                }

            } catch (error) {

                console.error(
                    'Footer localization error:',
                    error
                );

            }
        };

        dataOperationFunc().catch(console.error);

    }, []);


    /* =========================================================
       LABEL HELPER
    ========================================================= */

    const getLabel = (
        defaultText,
        controlId
    ) => {

        if (
            LocalizationLabelsArray &&
            LocalizationLabelsArray.length > 0
        ) {

            return replaceLoclizationLabel(
                LocalizationLabelsArray,
                defaultText,
                controlId
            );
        }

        return defaultText;
    };


    const languageCode =
        getLanguageCodeFromSession() || 'en';


    /* =========================================================
       SHARED INLINE STYLE HELPERS
    ========================================================= */

    const widgetTitleStyle = {
        color: COLORS.textLight,
        fontSize: '15px',
        fontWeight: 700,
        marginBottom: '18px',
        letterSpacing: '0.3px'
    };

    const linkStyle = {
        color: COLORS.textMuted,
        textDecoration: 'none',
        fontSize: '13.5px',
        transition: 'color 0.15s ease'
    };

    const linkHoverHandlers = {
        onMouseEnter: (e) => { e.currentTarget.style.color = COLORS.orange; },
        onMouseLeave: (e) => { e.currentTarget.style.color = COLORS.textMuted; }
    };


    /* =========================================================
       RENDER
    ========================================================= */

    return (
        <>

            {/* =====================================================
                DESKTOP / TABLET FOOTER — AMAZON STYLE (dark navy bands)
            ====================================================== */}

            <footer
                className="footer-area asure-electronic-footer"
                style={{
                    background: COLORS.dark,
                    color: COLORS.textMuted,
                    paddingBottom: isMobile ? '80px' : 0, // clears fixed mobile bottom nav
                    fontFamily: 'inherit'
                }}
            >

                {/* -----------------------------------------------
                    BACK TO TOP BAND
                ----------------------------------------------- */}

                <div
                    onClick={scrollToTop}
                    style={{
                        background: COLORS.darkAccent,
                        textAlign: 'center',
                        padding: '14px 10px',
                        cursor: 'pointer',
                        color: COLORS.textLight,
                        fontSize: '13px',
                        fontWeight: 600,
                        letterSpacing: '0.4px',
                        userSelect: 'none'
                    }}
                >
                    ▲ Back to top
                </div>


                <div className="asure-footer-hero">
                    <div className="asure-footer-orb asure-footer-orb--one"></div>
                    <div className="asure-footer-orb asure-footer-orb--two"></div>
                    <div className="container asure-footer-hero__content">
                        <div className="asure-footer-brand">
                            <span className="asure-footer-brand__mark"><img src={`${process.env.PUBLIC_URL}/favicon.png`} alt="Asuremart logo" /></span>
                            <div className="asure-footer-brand__identity">
                                <strong><span className="asure-footer-brand__asure">ASURE</span><span className="asure-footer-brand__mart">MART</span></strong>
                                <small>Powering smarter everyday living</small>
                            </div>
                        </div>
                        <div className="asure-footer-benefits">
                            <div><i className="fas fa-shield-alt"></i><span><strong>Genuine products</strong><small>Trusted electronics</small></span></div>
                            <div><i className="fas fa-truck"></i><span><strong>Fast delivery</strong><small>Across serviceable PINs</small></span></div>
                            <div><i className="fas fa-headset"></i><span><strong>Expert support</strong><small>We are here to help</small></span></div>
                        </div>
                    </div>
                </div>


                {/* -----------------------------------------------
                    MAIN LINK COLUMNS
                ----------------------------------------------- */}

                <div className="container" style={{ paddingTop: '40px', paddingBottom: '30px' }}>

                    <div className="row">

                        {/* =================================================
                            LOGO / ABOUT
                        ================================================= */}

                        <div className="col-lg-3 col-md-6" style={{ marginBottom: '30px' }}>

                            <div className="single-footer-widget">

                                <div className="logo" style={{ marginBottom: '16px' }}>

                                    <Link to={`/${languageCode}/`}>

                                        <div className="asure-footer-mini-logo"><i className="fas fa-microchip"></i><span>ASUREMART</span></div>

                                    </Link>

                                </div>

                                <p style={{ color: COLORS.textMuted, fontSize: '13.5px', lineHeight: '1.7' }}>
                                    Discover electronics, electrical essentials and smart hardware from trusted sellers—all in one dependable marketplace.
                                </p>

                            </div>

                        </div>


                        {/* =================================================
                            QUICK LINKS
                        ================================================= */}

                        <div className="col-lg-3 col-md-6" style={{ marginBottom: '30px' }}>

                            <div className="single-footer-widget">

                                <h3 id="lbl_footr_quicklink" style={widgetTitleStyle}>
                                    {getLabel("Quick Links", "lbl_footr_quicklink")}
                                </h3>

                                <ul className="quick-links" style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '10px' }}>

                                    <li>
                                        <Link to={`/${languageCode}/`} id="lbl_footr_home" style={linkStyle} {...linkHoverHandlers}>
                                            {getLabel("Home", "lbl_footr_home")}
                                        </Link>
                                    </li>

                                    <li>
                                        <Link to={`/${languageCode}/about`} id="lbl_footr_about" style={linkStyle} {...linkHoverHandlers}>
                                            {getLabel("About Us", "lbl_footr_about")}
                                        </Link>
                                    </li>

                                    <li>
                                        <Link to={`/${languageCode}/faq`} id="lbl_footr_faq" style={linkStyle} {...linkHoverHandlers}>
                                            {getLabel("Faq's", "lbl_footr_faq")}
                                        </Link>
                                    </li>

                                    <li>
                                        <a
                                            href={Config['ADMIN_BASE_URL']}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            style={linkStyle}
                                            {...linkHoverHandlers}
                                        >
                                            Admin Portal
                                        </a>
                                    </li>

                                </ul>

                            </div>

                        </div>


                        {/* =================================================
                            INFORMATION
                        ================================================= */}

                        <div className="col-lg-3 col-md-6" style={{ marginBottom: '30px' }}>

                            <div className="single-footer-widget">

                                <h3 id="lbl_footr_info" style={widgetTitleStyle}>
                                    {getLabel("Information", "lbl_footr_info")}
                                </h3>

                                <ul className="information-links" style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '10px' }}>

                                    <li>
                                        <Link to={`/${languageCode}/about`} style={linkStyle} {...linkHoverHandlers}>
                                            {getLabel("About Us", "lbl_footr_about")}
                                        </Link>
                                    </li>

                                    <li>
                                        <Link to={`/${languageCode}/contact-us`} id="lbl_footr_cont" style={linkStyle} {...linkHoverHandlers}>
                                            {getLabel("Contact Us", "lbl_footr_cont")}
                                        </Link>
                                    </li>

                                    <li>
                                        <Link to={`/${languageCode}/Terms`} id="lbl_footr_terms" style={linkStyle} {...linkHoverHandlers}>
                                            {getLabel("Terms and Condition", "lbl_footr_terms")}
                                        </Link>
                                    </li>

                                </ul>

                            </div>

                        </div>


                        {/* =================================================
                            CONTACT
                        ================================================= */}

                        <div className="col-lg-3 col-md-6" style={{ marginBottom: '30px' }}>

                            <div className="single-footer-widget">

                                <h3 id="lbl_footr_contact_title" style={widgetTitleStyle}>
                                    {getLabel("Contact Us", "lbl_footr_cont")}
                                </h3>

                                <ul
                                    className="footer-contact-info"
                                    style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '14px', fontSize: '13.5px', color: COLORS.textMuted, lineHeight: '1.6' }}
                                >

                                    <li style={{ display: 'flex', gap: '10px' }}>
                                        <i className="fas fa-map-marker-alt" style={{ color: COLORS.orange, marginTop: '3px' }}></i>
                                        <span>
                                            <span id="lbl_footr_location" style={{ color: COLORS.textLight, fontWeight: 600 }}>
                                                {getLabel("Location:", "lbl_footr_location")}
                                            </span>
                                            {' '}
                                            Theppakulam Street, Veppur
                                            <br />
                                            Perambalur, Tamil Nadu 621717, India
                                        </span>
                                    </li>

                                    <li style={{ display: 'flex', gap: '10px' }}>
                                        <i className="fas fa-map-marker-alt" style={{ color: COLORS.orange, marginTop: '3px' }}></i>
                                        <span>
                                            <span style={{ color: COLORS.textLight, fontWeight: 600 }}>Branch:</span>
                                            {' '}
                                            1911 RKV Nagar, No 1 Tolgate, Trichy, Tamil Nadu 621216, India
                                        </span>
                                    </li>

                                    <li style={{ display: 'flex', gap: '10px', alignItems: 'flex-start' }}>
                                        <i className="fas fa-phone" style={{ color: COLORS.orange, marginTop: '3px' }}></i>
                                        <span>
                                            <span id="lbl_footr_callus" style={{ color: COLORS.textLight, fontWeight: 600, display: 'block' }}>
                                                {getLabel("Call Us:", "lbl_footr_callus")}
                                            </span>
                                            <a href="tel:+919597172992" style={linkStyle} {...linkHoverHandlers}>
                                                +91 9597172992
                                            </a>
                                        </span>
                                    </li>

                                    <li style={{ display: 'flex', gap: '10px', alignItems: 'flex-start' }}>
                                        <i className="far fa-envelope" style={{ color: COLORS.orange, marginTop: '3px' }}></i>
                                        <span>
                                            <span id="lbl_footr_emailus" style={{ color: COLORS.textLight, fontWeight: 600, display: 'block' }}>
                                                {getLabel("Email Us:", "lbl_footr_emailus")}
                                            </span>
                                            <a href="mailto:support@asuremart.com" style={linkStyle} {...linkHoverHandlers}>
                                                support@asuremart.com
                                            </a>
                                        </span>
                                    </li>

                                </ul>

                            </div>

                        </div>

                    </div>

                </div>


                {/* =====================================================
                    COPYRIGHT BAND
                ====================================================== */}

                <div
                    className="copyright-area"
                    style={{
                        background: COLORS.darkest,
                        borderTop: `1px solid ${COLORS.border}`,
                        padding: '18px 0'
                    }}
                >

                    <div className="container">

                        <div className="row align-items-center">

                            <div
                                className="col-lg-6 col-md-6"
                                style={{ color: COLORS.textMuted, fontSize: '13px', marginBottom: isMobile ? '10px' : 0 }}
                            >
                                ASUREMART PTE LTD
                            </div>

                            <div className="col-lg-6 col-md-6">

                                <ul
                                    className="payment-card"
                                    style={{
                                        listStyle: 'none',
                                        display: 'flex',
                                        gap: '8px',
                                        justifyContent: isMobile ? 'flex-start' : 'flex-end',
                                        padding: 0,
                                        margin: 0,
                                        flexWrap: 'wrap'
                                    }}
                                >

                                    {paymentMethods && paymentMethods.map((item) => (

                                        <li
                                            key={item.PaymentMethodId}
                                            style={{
                                                background: '#fff',
                                                borderRadius: '4px',
                                                padding: '4px 6px',
                                                display: 'flex',
                                                alignItems: 'center'
                                            }}
                                        >
                                            <span>
                                                <img
                                                    src={adminPanelBaseURL + item.ImageUrl}
                                                    alt="payment"
                                                    style={{ height: '18px', display: 'block' }}
                                                />
                                            </span>
                                        </li>

                                    ))}

                                </ul>

                            </div>

                        </div>

                    </div>

                </div>

            </footer>


            {/* =========================================================
                AMAZON STYLE MOBILE BOTTOM NAVIGATION
            ========================================================== */}

            {isMobile && (

                <div
                    style={{
                        position: 'fixed',
                        left: 0,
                        right: 0,
                        bottom: 0,
                        width: '100%',
                        height: '68px',
                        background: '#ffffff',
                        borderTop: '1px solid #e5e5e5',
                        boxShadow: '0 -3px 18px rgba(0,0,0,0.14)',
                        zIndex: 99999,
                        display: 'flex',
                        alignItems: 'stretch',
                        justifyContent: 'space-around'
                    }}
                >

                    {/* =================================================
                        HOME
                    ================================================= */}

                    <Link
                        to={`/${languageCode}/`}
                        style={{
                            flex: 1,
                            height: '68px',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            textDecoration: 'none',
                            color: '#111111',
                            position: 'relative',
                            gap: '3px',
                            WebkitTapHighlightColor: 'transparent'
                        }}
                    >

                        <div
                            style={{
                                height: '29px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontSize: '20px'
                            }}
                        >
                            <i className="fas fa-home"></i>
                        </div>

                        <span
                            style={{
                                fontSize: '11px',
                                fontWeight: '600',
                                lineHeight: '14px',
                                color: '#222222'
                            }}
                        >
                            {getLabel("Home", "lbl_mgmenu_home")}
                        </span>

                    </Link>


                    {/* =================================================
                        CART
                    ================================================= */}

                    <button
                        type="button"
                        onClick={handleCart}
                        style={{
                            flex: 1,
                            height: '68px',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            border: 'none',
                            outline: 'none',
                            background: 'transparent',
                            color: '#111111',
                            position: 'relative',
                            gap: '3px',
                            padding: 0,
                            cursor: 'pointer',
                            WebkitTapHighlightColor: 'transparent'
                        }}
                    >

                        <div
                            style={{
                                height: '29px',
                                width: '34px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                position: 'relative',
                                fontSize: '20px'
                            }}
                        >

                            <i className="fas fa-shopping-cart"></i>

                            {/* CART COUNT */}

                            <span
                                style={{
                                    position: 'absolute',
                                    top: '-6px',
                                    right: '-3px',
                                    minWidth: '18px',
                                    height: '18px',
                                    padding: '0 4px',
                                    borderRadius: '20px',
                                    background: COLORS.orange,
                                    color: '#ffffff',
                                    fontSize: '9px',
                                    fontWeight: '700',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    border: '2px solid #ffffff',
                                    boxSizing: 'border-box'
                                }}
                            >
                                {totalCartItems ?? 0}
                            </span>

                        </div>

                        <span
                            style={{
                                fontSize: '11px',
                                fontWeight: '600',
                                lineHeight: '14px',
                                color: '#222222'
                            }}
                        >
                            {getLabel("Cart", "lbl_mgmenu_cart")}
                        </span>

                    </button>


                    {/* =================================================
                        WISHLIST
                    ================================================= */}

                    <button
                        type="button"
                        onClick={handleWishlist}
                        style={{
                            flex: 1,
                            height: '68px',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            border: 'none',
                            outline: 'none',
                            background: 'transparent',
                            color: '#111111',
                            position: 'relative',
                            gap: '3px',
                            padding: 0,
                            cursor: 'pointer',
                            WebkitTapHighlightColor: 'transparent'
                        }}
                    >

                        <div
                            style={{
                                height: '29px',
                                width: '34px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                position: 'relative',
                                fontSize: '20px'
                            }}
                        >
                            <i className="far fa-heart"></i>
                        </div>

                        <span
                            style={{
                                fontSize: '11px',
                                fontWeight: '600',
                                lineHeight: '14px',
                                color: '#222222'
                            }}
                        >
                            {getLabel("Wishlist", "lbl_mgmenu_wishlist")}
                        </span>

                    </button>


                    {/* =================================================
                        ACCOUNT / LOGIN
                    ================================================= */}

                    {
                        loginUser &&
                        loginUser.UserID !== undefined &&
                        loginUser.UserID > 0
                            ?

                            <Link
                                to={`/${languageCode}/orders-history`}
                                style={{
                                    flex: 1,
                                    height: '68px',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    textDecoration: 'none',
                                    color: '#111111',
                                    position: 'relative',
                                    gap: '3px',
                                    WebkitTapHighlightColor: 'transparent'
                                }}
                            >

                                <div
                                    style={{
                                        height: '29px',
                                        width: '34px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        fontSize: '20px'
                                    }}
                                >
                                    <i className="fas fa-user-circle"></i>
                                </div>

                                <span
                                    style={{
                                        maxWidth: '75px',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'nowrap',
                                        fontSize: '11px',
                                        fontWeight: '600',
                                        lineHeight: '14px',
                                        color: '#222222'
                                    }}
                                >
                                    {loginUser.FirstName || "Account"}
                                </span>

                            </Link>

                            :

                            <Link
                                to={`/${languageCode}/login`}
                                style={{
                                    flex: 1,
                                    height: '68px',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    textDecoration: 'none',
                                    color: '#111111',
                                    position: 'relative',
                                    gap: '3px',
                                    WebkitTapHighlightColor: 'transparent'
                                }}
                            >

                                <div
                                    style={{
                                        height: '29px',
                                        width: '34px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        fontSize: '20px'
                                    }}
                                >
                                    <i className="fas fa-user-circle"></i>
                                </div>

                                <span
                                    style={{
                                        fontSize: '11px',
                                        fontWeight: '600',
                                        lineHeight: '14px',
                                        color: '#222222'
                                    }}
                                >
                                    {getLabel("Login", "lbl_mgmenu_login")}
                                </span>

                            </Link>
                    }

                </div>

            )}


            {/* =========================================================
                WISHLIST MODAL
            ========================================================== */}

            {display && (
                <Wishlist handleWishlist={handleWishlist} />
            )}

        </>
    );
};

export default Footer;
